// extracted by mini-css-extract-plugin
export default {"formRow":"invoice_formRow__vGfIf","doNotPromptInput":"invoice_doNotPromptInput__wtc54"};